import { Route } from 'react-router-dom';
import {
  outOfNavRoutes,
  routes
} from '../utils/constants/ownerPensionerRoutes';
import { OwnerPensionerDashboard } from '../routes/dashboards/OwnerPensionerDashboard';
import { ShowMyDocuments } from '../routes/usersShows/documents/ShowMyDocuments';
import { PetSittingAddressRouter } from '../routes/usersShows/petSittingAddress/PetSittingAddressRouter';
import { AnimalsRouter } from '../routes/usersShows/animals/AnimalsRouter';
import { SupervisionsRouter } from '../routes/usersShows/supervisions/SupervisionsRouter';
import { VeterinarianGroomerRouter } from '../routes/usersShows/veterinarianGroomer/VeterinarianGroomerRouter';
import { BaseUserRouter } from './BaseUserRouter';

/**
 * OwnerRouter component.
 * @component
 *
 * Router component for owner operations.
 * @returns {ReactElement} The OwnerRouter component.
 */
export const OwnerRouter = () => (
  <BaseUserRouter
    outOfNavRoutes={outOfNavRoutes}
    dashboardComponent={<OwnerPensionerDashboard />}
    additionalRoutes={[
      <Route
        key="pet-sitting-address"
        path={`${routes.PET_SITTING_ADDRESS}/*`}
        element={<PetSittingAddressRouter />}
      />,
      <Route
        key="animals"
        path={`${routes.ANIMALS}/*`}
        element={<AnimalsRouter />}
      />,
      <Route
        key="supervisions"
        path={`${routes.SUPERVISIONS}/*`}
        element={<SupervisionsRouter />}
      />,
      <Route
        key="veterinarian-groomer"
        path={`${routes.VETERINARIAN_GROOMER}/*`}
        element={<VeterinarianGroomerRouter />}
      />,
      <Route
        key="documents"
        path={routes.DOCUMENTS}
        element={<ShowMyDocuments />}
      />
    ]}
  />
);
